import axios from "axios";

const client = axios.create({
    // baseURL: `http://spurr-api-dev.gospurr.com/qrorder`,
    baseURL: `http://spurr-api.gospurr.com/qrorder`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });



export default client
